import {
  alias,
  custom,
  deserialize,
  object,
  serializable,
  SKIP,
} from 'serializr';
import { Subscription } from './subscription.model';
import { Base } from './base.model';

export class Tenant extends Base {
  @serializable
  public tsid: string;
  @serializable
  public domain: string;
  @serializable
  public name: string;
  @serializable
  public company: string;
  @serializable(
    alias(
      'email',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public registeredEmail: string;
  @serializable(object(Subscription))
  public subscription: Subscription;
  @serializable(
    alias(
      'identityAccountUUId',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public identityServiceId: string;
  @serializable
  public reportCustomisationEnabled: boolean;
  @serializable
  public companyLogoName: string;
  @serializable
  public logoFile: File;

  @serializable
  public companyLogoPreSignedURL: string;
  deserialize(input: any): this {
    return Object.assign(this, deserialize(Tenant, input));
  }
}
